import { BaseVue, Component, Prop, Mutation } from '@newview/base-web';
@Component({
    components: {}
})
export default class HeaderPanel extends BaseVue {

    @Prop({ default: false })
    view?: boolean;
    @Prop({ default: true })
    back?: boolean;
    @Prop({ default: "" })
    headerTitle?: string;

    iconSize: number = 18;

    sceneList: any[] = [
        { id: "01", name: '主场景', type: 'plane', contentSchema: {}, schema: {} },
        { id: "02", name: '副场景', type: 'plane', contentSchema: {}, schema: {} },
        { id: "03", name: '编辑弹框', type: 'modal', contentSchema: {}, schema: {} },
        { id: "04", name: '抽屉', type: 'drawer ', contentSchema: {}, schema: {} },
    ];
    selectedScene: any = "";

    showEditScene: boolean = false;
    editScene: string = "添加视图";

    mounted() { }

    onSave() {
        this.$emit('save');
    }

    onRefresh() {
        this.$emit('refresh');
    }

    onBack() {
        this.$emit('back');
    }

    /**
     * 添加场景
     */
    doAddScene() {
        this.showEditScene = true;
        this.editScene = "添加场景";
    }
}